module.exports = __webpack_public_path__ + "img/V-63-ER-1500-N.592545e2.png";